import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Col, Row } from 'react-grid-system';
import H1 from '../../atoms/title/H1';
import Layout from '../../templates/Layout';
// import DossierTable from '../../organisms/table/DossierTable';
import Filters from '../../organisms/dossier/Filters';
import PaginationList from '../../molecules/PaginationList';
import { router } from '@inertiajs/react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useDossierFilters } from '../../hooks/useDossierFilters';
import DossierTable from '../../organisms/table/DossierTable';
const Overview = ({ dossiers, filters: initialFilters, availableFilters, }) => {
    if (Array.isArray(initialFilters)) {
        initialFilters = { status: 'open' };
    }
    const { t } = useTranslation();
    const [page, setPage] = useState(dossiers.current_page);
    const [loading, setLoading] = useState(false);
    const { filters, setFilter, setFilters, previousFilters, setPreviousFilters, } = useDossierFilters(initialFilters);
    router.on('finish', event => {
        if (!event.detail.visit.interrupted) {
            setLoading(false);
        }
    });
    const reload = () => {
        // Do not use `Inertia.reload()` here
        // @see {@link https://github.com/inertiajs/inertia/issues/65}
        // Simply put: array params will duplicate and the URL becomes a mess.
        // Hours wasted here = 4
        router.replace(location.pathname, {
            data: { page, ...filters },
            only: ['dossiers', 'filters'],
        });
    };
    useEffect(() => {
        if (dossiers.current_page !== page) {
            reload();
        }
    }, [page]);
    let debounceTimer;
    useEffect(() => {
        setLoading(true);
        window.clearTimeout(debounceTimer);
        debounceTimer = window.setTimeout(() => {
            const differenceCount = Object.entries(filters).filter(([key, value]) => {
                const filterKey = key;
                const previousValue = previousFilters[filterKey] || '';
                const currentValue = value || '';
                return previousValue !== currentValue;
            }).length;
            if (differenceCount) {
                setPreviousFilters({ ...filters });
                setPage(1);
                reload();
            }
            else {
                setLoading(false);
            }
        }, 500);
        return () => {
            window.clearTimeout(debounceTimer);
        };
    }, [filters]);
    useEffect(() => {
        return () => {
            window.clearTimeout(debounceTimer);
        };
    }, []);
    return (_jsxs(Layout, { "data-testid": "dossier-overview", children: [_jsx(Helmet, { children: _jsx("title", { children: t('dossiers.title') }) }), _jsx(H1, { "data-testid": "title", children: t('dossiers.title') }), _jsx(Row, { children: _jsxs(Col, { sm: 12, children: [_jsx(Filters, { filters: filters, setFilter: setFilter, setFilters: setFilters, availableFilters: availableFilters || {} }), _jsx(DossierTable, { loading: loading, dossiers: dossiers.data, filters: filters }), _jsx(PaginationList, { disabled: loading, links: dossiers.links, setPage: setPage })] }) })] }));
};
export default Overview;
